/**
 * IANA timezone identifiers for country-pack configuration.
 *
 * Uses the runtime IANA database when available (Intl.supportedValuesOf), with a static
 * fallback for environments that do not expose it (older browsers, some test runners).
 */
const IANA_TIMEZONE_FALLBACK: readonly string[] = [
  'Africa/Abidjan',
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Africa/Lagos',
  'Africa/Nairobi',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Mexico_City',
  'America/New_York',
  'America/Sao_Paulo',
  'America/Toronto',
  'Asia/Bangkok',
  'Asia/Dubai',
  'Asia/Hong_Kong',
  'Asia/Jakarta',
  'Asia/Kolkata',
  'Asia/Kuala_Lumpur',
  'Asia/Manila',
  'Asia/Riyadh',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Taipei',
  'Asia/Tokyo',
  'Australia/Melbourne',
  'Australia/Perth',
  'Australia/Sydney',
  'Europe/Amsterdam',
  'Europe/Berlin',
  'Europe/Dublin',
  'Europe/London',
  'Europe/Madrid',
  'Europe/Paris',
  'Europe/Rome',
  'Europe/Zurich',
  'Pacific/Auckland',
  'Pacific/Fiji',
  'UTC',
];

function resolveIanaTimezones(): readonly string[] {
  try {
    const intl = Intl as typeof Intl & { supportedValuesOf?: (key: string) => string[] };
    if (typeof intl.supportedValuesOf === 'function') {
      const zones = intl.supportedValuesOf('timeZone').slice().sort((a, b) => a.localeCompare(b));
      if (zones.length) return Object.freeze(zones);
    }
  } catch {
    /* use fallback */
  }
  return Object.freeze([...IANA_TIMEZONE_FALLBACK]);
}

export const IANA_TIMEZONES: readonly string[] = resolveIanaTimezones();

export function ianaTimezoneOptions(): { value: string; label: string }[] {
  return IANA_TIMEZONES.map((zone) => ({ value: zone, label: zone }));
}
